import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { environment } from "../../../../../environments/environment";
import { ProvidersService } from "../../providers.service";
import { IProvider, IProviderCost } from "../../models/providers";
import moment from "moment";

@Component({
  selector: "app-providers-detail",
  templateUrl: "./providers-detail.component.html",
  styleUrls: ["./providers-detail.component.scss"],
})
export class ProvidersDetailComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public providerId: number;
  public provider: IProvider = null;
  public providerCosts: IProviderCost[] = [];
  public availableYears: string[] = [];
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public selectedYear: string = moment().format("YYYY");
  public selectedMonth: string = "0";
  public totalCost: number = 0;
  public filteredProviderCost: IProviderCost[] = [];
  constructor(
    private _activatedRoute: ActivatedRoute,
    public _authenticationService: AuthenticationService,
    public router: Router,
    public _utilService: UtilsService,
    public _providerService: ProvidersService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this._utilService.disableAutoHideLoading();
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      const providerId: number = Number(params.get("id"));
      if (providerId) {
        if (!this._authenticationService.hasCapability("detail_provider")) {
          await this.router.navigateByUrl("/dashboard/main");
          return false;
        }
        this.providerId = providerId;
      }
    });
    for (let i: number = 2023; i <= Number(this.selectedYear) + 1; i++) {
      this.availableYears.push(String(i));
    }
    this.contentHeader = {
      headerTitle: "MENU.PROVIDERS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.EXTERNAL_USERS_LIST",
            isLink: true,
            link: "/dashboard/providers/list",
          },
          {
            name: "MENU.PROVIDER_DETAIL",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    await this.loadProvider();
  }
  async loadProvider() {
    this.totalCost = 0;
    await this._providerService
      .get(this.providerId)
      .then(async (provider: IProvider) => {
        this.provider = provider;
        if (!provider) {
          this._utilService.hideLoading();
          await this._utilService.showToastrError("PROVIDER_NOT_FOUND");
          await this.router.navigateByUrl("/dashboard/main");
          return false;
        } else {
          if (this.provider.logo) {
            this.provider.logo = environment.CDN_URL + "/" + this.provider.logo;
          }
          if (this._authenticationService.hasCapability("show_menu_commission")) {
            await this._providerService.getProviderCosts(this.providerId, this.selectedYear).then((response: IProviderCost[]) => {
              this.providerCosts = response;
            });
          }

          this.contentHeader.headerTitle = this.provider.name;
        }
        this.filter();

        this._utilService.hideLoading();
        this._changeDetectorRef.detectChanges();
      })
      .catch(async (err) => {
        console.error(err);
        this._utilService.hideLoading();
        await this._utilService.showToastrError("PROVIDER_NOT_FOUND");
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      });
  }

  filter() {
    let items: IProviderCost[] = this.providerCosts;
    if (this.selectedMonth && Number(this.selectedMonth) > 0) {
      items = items.filter((cost) => cost.month == Number(this.selectedMonth));
    }
    this.filteredProviderCost = items;
    this.calculateTotalCost();
  }

  formatMonth(month: number, format: string = "MMMM") {
    const date: moment.Moment = moment();
    date.set("month", month - 1);
    return date.format(format);
  }

  calculateTotalCost() {
    if (this.filteredProviderCost && this.filteredProviderCost.length > 0) {
      this.filteredProviderCost.map((cost) => {
        if (!!cost.amount && Number(cost.amount) > 0) {
          this.totalCost += Number(cost.amount);
        }
      });
    }
  }
}
